// extracted by mini-css-extract-plugin
export default {"root":"-ihq6-lQTyFolE-BO8aETg==","input":"KEd00LjNQ5Iy+mxUiEZp1A==","hasLabel":"GiinjWhQlql0PpybU15X0w=="};